import { h, Fragment } from 'preact';
import { useCallback, useState } from 'preact/hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from 'utils/image';
import Video from 'utils/reactVideo';
import ProductBadges from './product-badges';
import ProductGalleryZoom from './product-gallery-zoom';
import Icon from '../utils/icon';

const ProductGallery = ({ 
  product, 
  media,
  isMobile,
  portraitImages
}) => {
  // eslint-disable-next-line
  const [vimeoPlayer, setVimeoPlayer] = useState(null);
  const onPlayerInit = useCallback((player) => setVimeoPlayer(player), []);
  const [zoomIndex, setZoomIndex] = useState(null); 

  const portraitRatioClass = 'aspect-[164/217] md:aspect-[342/454]';
  const landscapeRatioClass = 'aspect-[330/217] md:aspect-[694/454]';

  const isPortrait = (image,index,mobile = false) => {

    if (image?.alt?.includes('[portrait]')){
      return true 
    } 
    if (image?.alt?.includes('[landscape]')) { 
      return false
    }

    const positionCounter = index + 1
    if(!portraitImages){
      if((index === 1 || index === 2)){
        return true 
      } 
      return false
    } 

    if(portraitImages && positionCounter % 3 === 0){
      return false 
    }

    if(mobile && (image.media_type === 'video' || image.media_type === 'external_video')){
      return false
    }

    return true
  }

  const zoomIcon = () => {
    const productGallerySlider = document.querySelector('[data-product-gallery-slider]')
    const activeSlide = productGallerySlider?.querySelector('.swiper-slide-active')
    let activeIndex = activeSlide?.getAttribute('aria-label').split('/')[0]
    activeIndex = parseInt(activeIndex, 10) - 1
    enableZoom(activeIndex)
  }

  const enableZoom = (index) => {
    const body = document.querySelector('body')
    const header = document.querySelector('#shopify-section-header')
    if(index === null){
      header?.classList.add('z-10')
      body.classList.remove('overflow-y-hidden')
    } else {
      header?.classList.remove('z-10')
      body.classList.add('overflow-y-hidden')
    }
    setZoomIndex(index);
  }

  return (
    !isMobile ? (
      <div className='grid grid-cols-2 gap-2 relative'>
        {product?.badges?.length ? <ProductBadges badges={product?.badges} /> : ''} 
        {media?.map((mediaItem, index) => (
          mediaItem.media_type === 'image' ? (
            <div 
              className=
                {`
                  cursor-zoom-in ${isPortrait(mediaItem,index) ? 'col-span-1' : 'col-span-2'} ${product?.blendMode && 'bg-grey-5'}`
                }
              key={index}
              onClick={() => enableZoom(index)}
            >
              <Image
                {...mediaItem}
                srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }}
                classes={`w-full h-full min-h-full object-cover 
                  ${isPortrait(mediaItem, index) ?
                    portraitRatioClass : landscapeRatioClass}
                  ${product?.blendMode && 'mix-blend-darken'}`}
              />
            </div>
          ) : mediaItem.media_type === 'external_video' ? (
            <div 
              className='cursor-zoom-in aspect-video relative col-span-2'
              key={index}  
              onClick={() => enableZoom(index)}
            >
              <Video
                className='h-full w-full relative z-1' 
                autoplay={true}
                loop={true}
                externalId={mediaItem.external_id}
                id={mediaItem.id}
                onPlayerInit={onPlayerInit}
                showControls={false}
              />
            </div>
          ) : mediaItem.media_type === 'video' ? (
            <div 
              className='cursor-zoom-in aspect-video relative col-span-2' 
              key={index}
              onClick={() => enableZoom(index)}
              >
              <Video
                className='h-full w-full relative z-1'
                autoplay={true}
                loop={true}
                isHTML5={true}
                id={media.id}
                videoSrc={mediaItem.sources[1].url}
                showControls={false}
              />
            </div>
          ) : <div 
					className=
						{`
							cursor-zoom-in ${isPortrait(mediaItem,index) ? 'col-span-1' : 'col-span-2'}`
						}
					key={index}
					onClick={() => enableZoom(index)}
				>
					<Image
						src={mediaItem}
						srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }}
						classes={`w-full h-full min-h-full object-cover 
							${isPortrait(mediaItem, index) ?
								portraitRatioClass : landscapeRatioClass}
              ${product?.blendMode && 'mix-blend-darken'}`}
					/>
				</div>
        ))}
        {zoomIndex !== null && 
          <ProductGalleryZoom 
            media={media} 
            index={zoomIndex} 
            enableZoom={enableZoom}
            enableBlendMode={product?.blendMode}
          />
        }
      </div>
    ) : (
      <Fragment>
        <Swiper 
          slidesPerView="auto"
          slidesPerGroupAuto={true}
          spaceBetween={4}
          data-product-gallery-slider
        >
          {media?.map((mediaItem, index) => (
            <SwiperSlide key={mediaItem.id} className={`!h-[222px] ${isPortrait(mediaItem,index,true) ? '!w-[176px]' : '!w-[336px]'}`}> 
              {mediaItem.media_type === 'image' ? 
              <div className='h-full' onClick={() => enableZoom(index)}>
                <Image
                  {...mediaItem}
                  srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }}
                  classes={`cursor-zoom-in object-cover h-full w-full`}
                  onClick={() => enableZoom(index)}
                /> 
              </div>
              : mediaItem.media_type === 'external_video' ? 
                <div className='relative w-full h-full' onClick={() => enableZoom(index)}>
                  <Video
                    className="h-full w-full relative z-1"
                    autoplay={true}
                    loop={true}
                    externalId={mediaItem.external_id}
                    id={mediaItem.id}
                    onPlayerInit={onPlayerInit}
                    showControls={false}
                  />
                </div>
              : mediaItem.media_type === 'video' ?
                <div className='relative w-full h-full' onClick={() => enableZoom(index)}>
                  <Video
                    className='h-full w-full relative z-1'
                    autoplay={true}
                    loop={true}
                    isHTML5={true}
                    id={media.id}
                    videoSrc={mediaItem.sources[1].url}
                    showControls={false}
                  />
                </div> : 
								<div className='h-full' onClick={() => enableZoom(index)}>
									<Image
										src={mediaItem}
										srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }}
										classes={`cursor-zoom-in object-cover h-full w-full`}
										onClick={() => enableZoom(index)}
									/> 
              	</div>
              }
            </SwiperSlide>
          ))}
          {zoomIndex !== null && 
            <ProductGalleryZoom 
              media={media} 
              index={zoomIndex} 
              enableZoom={enableZoom} 
              isMobile={isMobile} 
            />
          }
          <div 
            className='absolute bottom-1.5 left-1.5 cursor-pointer z-10'
            onClick={zoomIcon}
          >
            <Icon name='zoom-icon' />
          </div>
        </Swiper>
      </Fragment>
    )
  )
};

export default ProductGallery;